<template>
  <div class="settings" style="height: 100%">
    <div class="container">
      <div class="inner">
        <div class="header">
          <img class="icon" src="@/assets/technics.svg" />
          <h1 class="text">各種設定</h1>
          <div class="header-description">テスト・トレーニングの成績など、保存したデータの初期化などを行えます</div>
        </div>

        <Modal
          ref="cleanLessonProgressModal"
          title="レッスン進捗データの初期化"
          titleIcon="el-icon-remove"
          bodyHeight="240px"
          footerHeight="100px"
          :visibleNeverShowCheckbox="false"
          @agreeButtonClicked="cleanLessonProgress()"
        >
          <p></p>
          <p>本当に初期化しますか？</p>
        </Modal>

        <Modal
          ref="cleanTestResultsModal"
          title="テスト受験履歴の初期化"
          titleIcon="el-icon-remove"
          bodyHeight="240px"
          footerHeight="100px"
          :visibleNeverShowCheckbox="false"
          @agreeButtonClicked="cleanTestResults()"
        >
          <p></p>
          <p>本当に初期化しますか？</p>
        </Modal>

        <Modal
          ref="stopSubscriptionModal"
          title="自動継続課金の停止"
          titleIcon="el-icon-remove"
          bodyHeight="240px"
          footerHeight="100px"
          :visibleNeverShowCheckbox="false"
          @agreeButtonClicked="stopSubscription()"
        >決定ボタンを押すと、自動継続課金が停止されます。</Modal>
        <Modal
          ref="deleteAccountModal"
          title="アカウントを完全に削除"
          bodyHeight="270px"
          footerHeight="100px"
          :visibleNeverShowCheckbox="false"
          @agreeButtonClicked="deleteAccount()"
        >
          <div style="display: flex; flex-direction: column; width: 100%">
            <p>「ネイティブの口」アカウントを完全に削除します。</p>
            <p>この処理を取り消すことはできないので、十分に確認してから実行してください。</p>
          </div>
        </Modal>
        <Modal
          ref="cardEditModal"
          title="クレジットカード情報を変更"
          titleIcon="el-icon-bank-card"
          :visibleNeverShowCheckbox="false"
          @agreeButtonClicked="editCard()"
        >
          <div style="display: flex; flex-direction: column; width: 100%">
            <p>新しいクレジットカードの情報を入力してください。</p>
            <CreditCard ref="card" />
          </div>
        </Modal>
        <div class="configs">
          <div class="config-item">
            <div class="description">
              <div class="title">ご使用中アカウント情報</div>
              <dl>
                <dt>メールアドレス</dt>
                <dd>{{ $store.state.auth.user.email }}</dd>
                <!-- <dt>トライアル</dt>
                <dd>ご体験済み</dd>-->
              </dl>
            </div>
          </div>
          <div class="config-item">
            <div class="description">
              <div class="title">ニックネームの変更</div>
              <p>ランキングで表示されるニックネームを変更します。</p>
            </div>
            <button class="button" @click="$emit('showChangeNicknameModal')">ニックネームの変更</button>
          </div>
          <div class="config-item" v-if="active && !$store.state.userData.serialUsed">
            <div class="description">
              <div class="title">クレジットカード情報の更新</div>
              <Source />
            </div>
            <button class="button" @click="showEditCredit">カード情報を編集</button>
          </div>
          <div class="config-item" v-if="active && !$store.state.userData.serialUsed">
            <div class="description">
              <div class="title">課金情報</div>
              <p>
                現在
                <strong>
                  <span v-if="subscription.status === 'trialing'">トライアル期間中</span>
                  <span v-if="subscription.status === 'active'">{{planName}}</span>
                </strong>です。
                <strong>
                  {{
                  unixToDate(subscription.current_period_start * 1000)
                  }}
                </strong>から
                <strong>
                  {{
                  unixToDate(subscription.current_period_end * 1000)
                  }}
                </strong>
                まで本サービスをご利用可能です。
                <span v-if="!subscription.cancel_at_period_end">
                  {{
                  unixToDate(subscription.current_period_end * 1000)
                  }}に自動的に延長手続きが行われ、クレジットカードへの課金が行われます。
                  継続自動課金を停止する場合は、右のボタンから手続きを行ってください。
                </span>
                <el-alert
                  type="warning"
                  title="注意"
                  :closable="false"
                  style="margin: 10px 0"
                  show-icon
                >現在お申し込みのプランが終了するまでは、プランの変更はできません。</el-alert>
                <!-- <el-alert
                  v-if="$store.state.userData.trialed"
                  type="error"
                  title="注意"
                  :closable="false"
                  style="margin: 10px 0"
                  show-icon
                >お客様は既にトライアルを完了しているので、無料期間はございません。手続き後すぐに課金が開始されますのでご注意ください。</el-alert>-->
              </p>
            </div>
            <button
              v-if="!subscription.cancel_at_period_end"
              class="button"
              @click="showStopSubscription()"
            >自動継続課金の停止</button>
            <p v-if="subscription.cancel_at_period_end" class="canceled">自動継続課金停止済み</p>
          </div>
          <template v-if="!$store.state.userData.serialUsed">
            <div class="config-item" v-if="active && $store.state.userData.unlock">
              <div class="description">
                <div class="title">全レッスン解除の課金情報</div>
                <dl>
                  <dt>「全レッスンのロック解除」をご購入済みです。</dt>
                  <dd>ご購入日時： {{fbDateToString($store.state.userData.unlockedTime.seconds * 1000)}}</dd>
                </dl>
              </div>
            </div>
          </template>
          <div class="config-item" v-if="active">
            <div class="description">
              <div class="title">テストデータの初期化</div>
              <p>テストの受験履歴を初期化します。</p>
            </div>
            <button class="button" @click="showCleanTestResults()">テストデータの初期化</button>
          </div>
          <div class="config-item" v-if="active">
            <div class="description">
              <div class="title">レッスン進捗データの初期化</div>
              <p>各単語・フレーズで獲得したすべての点数履歴を初期化します。</p>
            </div>
            <button class="button" @click="showCleanLessonProgress()">レッスン進捗の初期化</button>
          </div>

          <div class="config-item">
            <div class="description">
              <div class="title">パスワードの変更</div>
              <p>サインインするために必要なパスワードを変更します。</p>
            </div>
            <button class="button" @click="changePassword()">パスワードを変更する</button>
          </div>
          <div class="config-item">
            <div class="description">
              <div class="title">アカウントの削除</div>
              <p>「ネイティブの口」アカウントの削除を行います。</p>
            </div>
            <button class="button" @click="showDeleteAccount()">アカウントを削除</button>
          </div>
        </div>
        <!-- <div class="header">
          <img class="icon" src="@/assets/quality.svg" />
          <h1 class="text">壁紙変更</h1>
          <div class="header-description">
            スコアをためると好きな壁紙を選ぶことが出来ます。頑張ってすべて集めましょう！
          </div>
        </div>-->
        <div class="reward-list" v-show="false">
          <div
            v-for="reward in rewardList"
            :style="`background-image: url('${reward.bgUrl}');`"
            class="reward-item"
            :key="reward.bgUrl"
            @click="setBgImage(reward)"
          >
            <div
              class="not-available"
              v-show="$store.state.userData.totalScore < reward.neededScore"
            ></div>
            <!-- <div class="reward-name">{{reward.name}}</div> -->
            <div v-show="reward.name === `Default`" class="reward-name">Default</div>

            <img
              src="@/assets/lock.svg"
              alt="Locked"
              v-show="$store.state.userData.totalScore < reward.neededScore"
            />
          </div>
        </div>
      </div>
      <div style="text-align:center; transform: scale(1.1); margin-top: 50px" v-if="false">
        <!-- <Map /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import firebase from "firebase/app";
import "firebase/functions";
import { fbDateToString } from "@/utils/functions";

export default {
  mounted(){
    document.title = "ネイティブの口 | 各種登録";
  },
  components: {
    // Map: require("./Map").default,
    Modal: require("@/components/Modal").default,
    CreditCard: require("@/components/CreditCard").default,
    Source: require("@/components/Source").default
  },
  computed: {
    planName() {
      if (
        this.$store.state.userData.subscription.items &&
        this.$store.state.userData.subscription.items.data[0] &&
        this.$store.state.userData.subscription.items.data[0].plan
      )
        return this.$store.state.userData.subscription.items.data[0].plan
          .nickname;
    },
    totalScore() {
      return this.$store.state.userData.totalScore;
    },
    subscription() {
      return this.$store.state.userData.subscription;
    },
    active() {
      const status = this.$store.state.userData.subscription.status;
      return status === "trialing" || status === "active";
    }
  },
  methods: {
    fbDateToString,
    showCleanLessonProgress() {
      this.$refs.cleanLessonProgressModal.showModal();
    },
    showCleanTestResults() {
      this.$refs.cleanTestResultsModal.showModal();
    },
    cleanLessonProgress() {
      let self = this;
      let loading = Loading.service({
        fullscreen: true,
        message: "レッスン進捗データを初期化中"
      });
      const cleanLessonProgress = firebase
        .functions()
        .httpsCallable("cleanLessonProgress");
      cleanLessonProgress()
        .then(() => {
          self.$notify({
            type: "success",
            title: "成功",
            duration: 10000,
            message: `レッスン進捗データの初期化が完了しました。`
          });
        })
        .catch(err => {})
        .finally(() => {
          loading.close();
          this.$refs.cleanLessonProgressModal.closeModal();
        });
    },
    cleanTestResults() {
      let self = this;

      let loading = Loading.service({
        fullscreen: true,
        message: "テスト受験履歴の初期化中"
      });
      const cleanTestResults = firebase
        .functions()
        .httpsCallable("cleanTestResults");
      cleanTestResults()
        .then(() => {
          self.$notify({
            type: "success",
            title: "成功",
            duration: 10000,
            message: `テスト受験履歴の初期化が完了しました。`
          });
        })
        .catch(err => {})
        .finally(() => {
          loading.close();
          this.$refs.cleanTestResultsModal.closeModal();
        });
    },
    deleteAccount() {
      let self = this;
      const user = firebase.auth().currentUser;
      user
        .delete()
        .then(() => {
          self.$notify({
            type: "success",
            title: "アカウント削除の成功",
            duration: 0,
            message:
              "アカウントの削除が完了しました。「ネイティブの口」をご利用頂き有難うございました。"
          });
          self.$refs.deleteAccountModal.closeModal();

          self.$router.replace("/");
        })
        .catch(err => {
          let message = "";
          if (err.code === "auth/requires-recent-login") {
            message =
              "セキュリティ上の理由から、アカウントを完全に削除するには、直近にサインインする必要があります。一度サインアウト・サインインし直してから、再度削除をしてください。";
          }
          self.$notify({
            duration: 0,
            type: "error",
            title: "アカウント削除の失敗",
            message: "アカウントの削除が失敗しました。" + message
          });
          self.$refs.deleteAccountModal.closeModal();
        });
    },
    showDeleteAccount() {
      if (this.subscription.cancel_at_period_end === false && this.subscription.status === "active" ||
      this.subscription.cancel_at_period_end === false && this.subscription.status === "trialing") {
        this.$notify({
          type: "warning",
          title: "自動継続課金中",
          message: "アカウントを削除する前に自動継続課金を停止してください。"
        });
        // this.$refs.stopSubscriptionModal.showModal();
      } else {
        this.$refs.deleteAccountModal.showModal();
      }
    },
    changePassword() {
      let self = this;
      let loading = Loading.service({ fullscreen: true });
      firebase
        .auth()
        .sendPasswordResetEmail(self.$store.state.auth.user.email)
        .then(() => {
          self.$notify({
            type: "success",
            title: "成功",
            duration: 0,
            message: `ご使用のメールアドレス（${self.$store.state.auth.user.email}）に、パスワード再設定に必要なURLを送信しました。URLをクリックして引き続きパスワードの変更手続きをお願いします。`
          });
          loading.close();
        });
    },
    async editCard() {
      try {
        if (this.$refs.card.nameValid) {
          const result = await this.$refs.card.saveToken();
          this.$refs.cardEditModal.closeModal();
          this.$notify({
            title: "成功",
            message: "クレジットカード情報の変更が完了しました",
            type: "success"
          });
        }
      } catch (err) {
        this.$notify({
          title: "失敗",
          message: "クレジットカード情報の変更に失敗しました",
          type: "error"
        });
      }
    },
    showEditCredit() {
      this.$refs.cardEditModal.showModal();
    },
    showStopSubscription() {
      this.$refs.stopSubscriptionModal.showModal();
    },

    async stopSubscription() {
      let self = this;
      const subscStopLoading = Loading.service({
        lock: true,
        text:
          "現在解約の手続き中です、ウィンドウを閉じないようにお願い致します。",
        background: "rgba(255, 255, 255, 0.9)",
        customClass: "loading"
      });
      const subId = this.$store.state.userData.subscription.id;
      try {
        const stop = firebase.functions().httpsCallable("cancelSubscription");
        const result = await stop({ subId });
        await self.$store.dispatch("loadUserData");
        subscStopLoading.close();
        self.$refs.stopSubscriptionModal.closeModal();

        self.$notify({
          type: "success",
          title: "成功",
          duration: 0,
          message: `自動継続課金解約の手続きが完了しました。`
        });
      } catch (err) {
        self.$notify({
          type: "error",
          message: err
        });
        self.$refs.stopSubscriptionModal.closeModal();
      }
    },
    unixToDate(unix) {
      const date = new Date(unix);
      return `${date.getFullYear()}年${date.getMonth() +
        1}月${date.getDate()}日${date.getHours()}時${date.getMinutes()}分`;
    },
    setBgImage(reward) {
      const loadingInstance = Loading.service({ fullscreen: true });
      console.log(reward.neededScore < this.$store.state.userData.totalScore);
      if (true) {
        // if (reward.neededScore < this.$store.state.userData.totalScore) {
        setTimeout(() => {
          this.$store.commit("setBgUrl", reward.bgUrl);
          loadingInstance.close();
        }, 500);
      }
    }
  },
  data() {
    return {
      creditCardInfo: null,
      modalVisible: true,
      rewardList: [
        {
          bgUrl: `data:image/svg+xml;charset=utf8,%20%3Csvg%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20id%3D%22svg821%22%20version%3D%221.1%22%20viewBox%3D%220%200%20507.99999%20285.75001%22%20height%3D%221080%22%20width%3D%221920%22%3E%20%3Cdefs%20id%3D%22defs815%22%20%2F%3E%20%3Cmetadata%20id%3D%22metadata818%22%3E%20%3Crdf%3ARDF%3E%20%3Ccc%3AWork%20rdf%3Aabout%3D%22%22%3E%20%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%20%3Cdc%3Atype%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%20%2F%3E%20%3Cdc%3Atitle%3E%3C%2Fdc%3Atitle%3E%20%3C%2Fcc%3AWork%3E%20%3C%2Frdf%3ARDF%3E%20%3C%2Fmetadata%3E%20%3Cg%20transform%3D%22translate(-100%2C-11.249983)%22%20id%3D%22layer1%22%3E%20%3Cpath%20id%3D%22path1366%22%20d%3D%22M%20-8.315476%2C0.28867346%20-33.639881%2C299.64581%20153.08036%2C4.0684352%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%3Bfill-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1368%22%20d%3D%22m%20335.26488%2C-152.79168%2062.36607%2C319.76785%20129.26784%2C22.67858%20z%22%20style%3D%22fill%3A%23f6f6f6%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1385%22%20d%3D%22M%20-25.702381%2C356.34223%20318.63393%2C20.699388%20118.68453%2C-12.184539%20-63.877977%2C360.87795%20Z%22%20style%3D%22fill%3A%23f0f0f0%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1368-0%22%20d%3D%22M%20-17.575879%2C47.535698%2044.790191%2C367.30355%20174.05803%2C389.98213%20Z%22%20style%3D%22fill%3A%23f6f6f6%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-9%22%20d%3D%22M%20118.68453%2C-12.184539%2069.163539%2C405.10117%20434.28854%2C-6.91578%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.43682703px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-4%22%20d%3D%22M%20346.98214%2C39.598196%20321.65774%2C338.95535%20508.37797%2C43.377956%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%20%22%20%2F%3E%20%3Cpath%20id%3D%22path1385-9%22%20d%3D%22M%20127.75595%2C341.03421%20472.09227%2C5.3913519%20272.14286%2C-27.492575%2089.580357%2C345.56993%20Z%22%20style%3D%22fill%3A%23f0f0f0%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-9-7%22%20d%3D%22M%20514.80357%2C297.55545%2089.202353%2C319.70147%20509.42982%2C156.41576%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.29501727px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-9-76%22%20d%3D%22M%20364.37516%2C-36.375026%20314.85417%2C380.9107%20679.97917%2C-31.106266%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.43682703px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1385-6%22%20d%3D%22M%20423.71131%2C430.61456%20768.04763%2C94.971709%20568.09822%2C62.087782%20385.53572%2C435.15028%20Z%22%20style%3D%22fill%3A%23f0f0f0%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3C%2Fg%3E%3C%2Fsvg%3E`,
          name: "Default",
          neededScore: 0
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1510605395823-530474d7490f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2768&q=80",
          name: "Chicago",
          neededScore: 10000
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1518996842-64fc49f6e446?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
          name: "Corgi",
          neededScore: 12000
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1533743983669-94fa5c4338ec?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1583&q=80",
          name: "Cat",
          neededScore: 30000
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1524429656589-6633a470097c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
          name: "Colorado",
          neededScore: 50000
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1533165899829-6ddfc2f95fec?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1566&q=80",
          name: "New York",
          neededScore: 60000
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1505761671935-60b3a7427bad?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80",
          name: "London",
          neededScore: 70000
        },
        {
          bgUrl:
            "https://images.unsplash.com/photo-1495580847032-db0bac41d44b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
          name: "Arizona",
          neededScore: 80000
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
strong {
  /* color: #f88; */
}
.inner {
  /* margin: 0 30px; */
}

.reward-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.reward-item {
  width: 250px;
  height: 180px;
  background-size: cover;
  overflow: hidden;
  border: 1px solid #ddd;
  position: relative;
  z-index: 100;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  font-weight: bold;
  position: relative;
  margin: 10px;
  z-index: 100;
  border-radius: 5px;
  img {
    width: 65px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 300;
    cursor: default;
  }
  .reward-name {
    z-index: 200;
    cursor: default;
  }
  .reward-name-available {
    color: #fff;
  }
  .not-available {
    cursor: default;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 101;
    background-color: rgba(255, 255, 255, 0.88);
  }
  &:hover {
    opacity: 0.9;
    &::after() {
      content: "aa";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: #fff;
      z-index: 111;
    }
  }
}

.header {
  display: inline-block;
  width: 100%;
  margin: 20px 0 0 50px;
  h1 {
    margin: 5px 0;
    font-size: 1.9rem;
  }
  .header-description {
    display: block;
    margin-bottom: 20px;
    font-size: 1rem;
    font-weight: bold;
  }
  img,
  .text {
    vertical-align: middle;
    display: inline-block;
  }

  img {
    width: 38px;
    margin-right: 10px;
  }
}

.configs {
  background-color: #fff;
  border: 1px solid #ddd;
  width: 90%;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  flex-direction: column;
  .config-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 15px;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    button {
      height: 50%;
      flex: 210px;
      justify-self: flex-start;
    }
    .canceled {
      color: #f88;
      font-weight: bold;
      flex: 210px;
      text-align: center;
    }
    .description {
      width: 100%;
      .title {
        font-weight: bold;
      }
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        margin-right: 20px;
        font-size: 0.93rem;
      }
    }
    &:last-child {
      border: none;
    }
    &:hover {
      background-color: #fcfcfc;
    }
  }
}
</style>
